import { mapState } from 'vuex'
// const debug = require('debug')('OD::BaseMixin')

export default {
  data() {
    return {}
  },
  computed: {
    ...mapState({
      currentUser: state => state.user.currentUser,
    }),
  },
  watch: {},
  created() {},
  mounted() {},
  methods: {
    navigateTo(to) {
      this.$router.push(to)
    },
  },
}
